import { cn } from '~/src/lib/utils'

function Skeleton({
  className,
  animate = true,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  animate?: boolean
}) {
  return (
    <div
      className={cn(
        'rounded-md bg-black/10 dark:bg-white/10',
        {
          'animate-pulse': animate,
        },
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
